import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";
import { useLang } from "../i18n";
import { extras } from "../i18n";

const CARD_STYLES = [
  "bg-white text-topacio-ink",
  "bg-brand text-topacio-ink",
  "bg-topacio-red text-white",
  "bg-white text-topacio-ink",
];

function CountUp({ to, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 1.8,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to]);
  return (
    <span ref={ref}>
      {val}
      {suffix}
    </span>
  );
}

export default function Volume({ bikesCount }) {
  const { lang } = useLang();
  const x = extras[lang] || extras.es;
  const years = new Date().getFullYear() - 1991;
  // se retira la tarjeta "motos en flota" (índice 1) a petición del cliente
  const items = x.volume.items
    .filter((_, i) => i !== 1)
    .map((it, i) => (i === 0 ? { ...it, v: years } : it));

  return (
    <section id="volumen" data-testid="stats-section" className="max-w-7xl mx-auto px-6 py-24 md:py-32">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
        <div>
          <p className="eyebrow mb-4">{x.volume.eyebrow}</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight font-bold text-topacio-ink uppercase">
            {x.volume.title}
          </h2>
        </div>
        <span className="font-hand text-3xl md:text-4xl text-topacio-red -rotate-2 select-none">1991 → {new Date().getFullYear()}</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {items.map((it, i) => (
          <motion.div
            key={i}
            data-testid={`stat-card-${i}`}
            initial={{ opacity: 0, y: 32, rotate: i % 2 ? 1.5 : -1.5 }}
            whileInView={{ opacity: 1, y: 0, rotate: i % 2 ? 1 : -1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ rotate: 0, y: -6 }}
            className={`border-2 border-topacio-ink rounded-xl shadow-[6px_6px_0_0_#111] hover:shadow-[8px_8px_0_0_#111] transition-shadow p-8 flex flex-col justify-between min-h-[210px] ${CARD_STYLES[i % CARD_STYLES.length]}`}
          >
            <div className="font-display font-black text-5xl md:text-6xl tracking-tight leading-none">
              {it.static ? `${it.v}${it.suffix}` : <CountUp to={it.v} suffix={it.suffix} />}
            </div>
            <div className="mt-6">
              <div className="text-xs uppercase tracking-[0.2em] font-extrabold">{it.l}</div>
              <div className={`font-hand text-xl mt-1.5 ${i === 2 ? "text-brand" : "text-topacio-red"}`}>{it.note}</div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
